import { formatRupeeLabel } from '../../../../display-values/lumpsumPlanAmount'
import { PlanCategoryBucketKey } from '../../../api/types'
import type { LumpsumIdealPlanRecommendationApiResponse } from '../../api/idealRecommendation.types'
import { computeIdealFundAllocatedAmount } from '../../../../utils/lumpsum/planListUtils'
import { ALLOCATION_PLANS_THEME } from '../../../plans-list/header/common/riskProfileHeaderTheme'

type IdealPlanRecommendationHeroProps = {
  planDetails: LumpsumIdealPlanRecommendationApiResponse | null
  bucketType?: PlanCategoryBucketKey
}

export function IdealPlanRecommendationHero({
  planDetails,
  bucketType
}: IdealPlanRecommendationHeroProps) {
  const maintainAmount = resolveIdealMaintainAmount(planDetails, bucketType)

  return (
    <div className="px-5">
      <div className="flex flex-col gap-2">
        <div
          className="text-[14px] font-[500] leading-[130%]"
          style={{ color: ALLOCATION_PLANS_THEME.headerTextColor }}
        >
          Ideal Recommendation
        </div>
        <div className="text-[20px] leading-[130%] font-[400] text-[#6A6E6E] max-w-[90%]">
          {'Maintain '}
          <span className="font-[500] text-[#232323]">
            {formatRupeeLabel({ rawAmount: maintainAmount })}
            {' lump sum'}
          </span>
          {' in this fund'}
        </div>
      </div>
    </div>
  )
}

function resolveIdealMaintainAmount(
  planDetails: LumpsumIdealPlanRecommendationApiResponse | null,
  bucketType?: PlanCategoryBucketKey
): number {
  if (bucketType === PlanCategoryBucketKey.noActionFunds) {
    return planDetails?.currentValue ?? 0
  }
  return computeIdealFundAllocatedAmount(
    planDetails?.idealPortfolioValue,
    planDetails?.fundIdealAllocation
  )
}
